import { __rest } from "tslib";
import * as React from 'react';
import { Button, ButtonVariant } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
import { AlertContext } from './AlertContext';
export var AlertActionCloseButton = function AlertActionCloseButton(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      variantLabel = _a.variantLabel,
      props = __rest(_a, ["className", "onClose", 'aria-label', "variantLabel"]);

  return React.createElement(AlertContext.Consumer, null, function (_ref) {
    var title = _ref.title,
        alertVariantLabel = _ref.variantLabel;
    return React.createElement(Button, Object.assign({
      variant: ButtonVariant.plain,
      onClick: onClose,
      "aria-label": ariaLabel === '' ? "Close ".concat(variantLabel || alertVariantLabel, " alert: ").concat(title) : ariaLabel
    }, props), React.createElement(TimesIcon, null));
  });
};